import { render } from "./SubThemesSlug.vue?vue&type=template&id=634a759a"
import script from "./SubThemesSlug.vue?vue&type=script&lang=js"
export * from "./SubThemesSlug.vue?vue&type=script&lang=js"

import "./SubThemesSlug.vue?vue&type=style&index=0&id=634a759a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__